<div class="footer justify-content-center">
  <div
    class="footer-container d-flex flex-column flex-lg-row w-full gap-4 gap-md-0"
  >
    <div
      class="col-12 col-md-4 d-flex justify-content-center justify-content-md-start"
    >
      <a class="navbar-brand" routerLink="/">
        @if ($user()) {
          <img
            class="logo c-ml-20 c-mh-60"
            src="{{ displayImage($user()?.company?.logo_file) }}"
            alt="{{ $user()?.company?.company_name }} Logo"
            title="{{ $user()?.company?.company_name }}"
          />
        }
      </a>
    </div>
    <div class="links-section col-12 col-md-4 text-center text-md-start">
      <h4>RESOURCES & SUPPORT</h4>
      <ul class="list-unstyled">
        <!-- <li><a [routerLink]="['/resources/how-to-order']">How To Order</a></li> -->
        <li><a [routerLink]="['/resources/about-us']">About Us</a></li>
        <li><a [routerLink]="['/resources/promotions']">Promotions</a></li>
        @if ($user()?.company?.web_theme === 'wt2024_new') {
          <li><a [routerLink]="['/blog']">Blog</a></li>
        }
        <li><a [routerLink]="['/resources/shipping']">Shipping</a></li>
        <li>
          <a [routerLink]="['/resources/contact-us']">Contact Us</a>
        </li>
        <li><a [routerLink]="['/resources/faqs']">FAQs</a></li>
        <li>
          <a [routerLink]="['/resources/terms-and-conditions']"
            >Terms & Conditions</a
          >
        </li>
        <li>
          <a [routerLink]="['/resources/privacy-policy']">Privacy Policy</a>
        </li>
        <!-- <li>
          <a [routerLink]="['/resources/register']">Trade Register</a>
        </li> -->
      </ul>
    </div>
    <div
      class="newsletter-section col-12 col-md-4 text-center text-md-start px-4 px-md-0"
    >
      <h4>NEWSLETTER</h4>
      <p style="font-size: 16px">
        Sign up to hear about new products and promotions!
      </p>
      <form class="flex flex-column">
        <input
          class="border-round mb-3"
          type="email"
          placeholder="Email Address"
        />
        <div class="justify-content-center justify-content-md-start">
          <button class="w-3 border-round" type="submit">SUBSCRIBE</button>
        </div>
      </form>
    </div>
  </div>

  <div class="text-center-container" style="font-weight: bolder">
    <p>
      © {{ year }} {{ siteConfig?.system?.name ?? '' }}. All rights reserved.
    </p>
  </div>
</div>
